<vs-card *ngIf="filters$ | async as filters" class="overflow-hidden">
  <vs-card-header
    [config]="{
      title: 'Payments',
      subtitle: 'Payments and sales for this warranty. Select a payment to view its details or record a receipt.',
    }"
  ></vs-card-header>
  <ws-payments-table
    [filters]="filters"
    (rowClicked)="openPayment($event); paymentDetailsDialog.open()"
  ></ws-payments-table>
</vs-card>

<vs-dialog
  #paymentDetailsDialog
  [config]="{ dialogContainerClass: 'w-full max-w-[1100px] mx-4' }"
  (closed)="closePayment()"
>
  <vs-dialog-header [config]="{ title: 'Payment details', mode: 'simple', icon: 'credit-card-01' }"></vs-dialog-header>
  <ng-container *ngIf="paymentDetails$ | async as details">
    <p *ngIf="details.loading" class="p-6 text-gray-500" role="status">Loading payment details...</p>
    <div *ngIf="details.error" class="p-6" role="alert">
      <p class="text-danger mb-4">{{ details.error }}</p>
      <button vs-button appearance="outline" (click)="retryDetails()">Try again</button>
    </div>
    <ng-container *ngIf="details.payment as payment">
      <ws-payment-invoice
        *ngIf="payment.user && payment.taxes; else incompletePayment"
        [warranty]="warranty"
        [payment]="$any(payment)"
        [showGatewayAssignment]="true"
        (refresh)="paymentUpdated()"
      ></ws-payment-invoice>
      <ng-template #incompletePayment>
        <p class="p-6 text-gray-500">The customer or invoice details for this payment are unavailable.</p>
      </ng-template>
    </ng-container>
  </ng-container>
</vs-dialog>
